import styled from 'styled-components'

const Styled = styled.div`
.ant-picker {
    border-radius: 10px;
    min-width: 100%;
  }

.impact-select {
    width: 250px;
}
.export-btn {
  background: #399a69;
  border-color: #399a69;
}
`

export default Styled
